/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import "../../styles/main.scss"
import Header from "./Header/Header.js"
import Footer from "./Footer.js"

const Layout = ({ children, article }) => {
  const data = useStaticQuery(graphql`
    query LayoutQuery {
      site {
        siteMetadata {
          title
        }
      }
      allSanityMenuItem {
        nodes {
          title
          page {
            ... on SanityAuthorsPage {
              id
              pageUrl {
                current
              }
              pageTitle
            }
            ... on SanityInfoPage {
              id
              pageUrl {
                current
              }
              pageTitle
            }
          }
        }
      }
      allSanityContactInfo {
        nodes {
          phone
          email
        }
      }
      allSanitySocialMedia {
        nodes {
          title
          link
        }
      }
    }
  `)
  return (
    <div className="layout">
      <Header menuItems={data.allSanityMenuItem.nodes} />
      <div>
        <main className={article ? "layout__article" : "layout--tablet-width"}>
          {children}
        </main>
        <Footer
          contact={data.allSanityContactInfo.nodes}
          socialMedia={data.allSanitySocialMedia.nodes}
        />
      </div>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
